<template>
  <widget-field-attachment-layout
    class="widget-field-uploaded-attachment"
    :download-url="downloadUrl"
    @remove="$emit('remove')"
  >
    <widget-attachment-regular-layout
      :mime-type="mimeType"
      :name="name"
      :size="size"
      :preview-url="previewUrl"
    />
  </widget-field-attachment-layout>
</template>

<script lang="ts" setup>
import WidgetAttachmentRegularLayout from '@widgets/shared/components/attachment/WidgetAttachmentRegularLayout.vue'
import WidgetFieldAttachmentLayout from '@widgets/shared/components/attachment/field/WidgetFieldAttachmentLayout.vue'

const { mimeType, name, size, downloadUrl, previewUrl } = defineProps<{
  mimeType: string // application/pdf
  name: string // file.pdf
  size: number // in bytes
  downloadUrl: string
  previewUrl?: string
}>()

defineEmits<{
  (event: 'remove'): void
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.widget-field-uploaded-attachment {
  &:hover {
    --widget-attachment-full-name-color: #{$blue};
  }
}
</style>
